import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProviderPurchasesReportFilters} from '../../../../Models/Reports/Purchases/Provider-purchases/provider-purchases-report-filters.model';
import {ProductPurchasesReportFilters} from '../../../../Models/Reports/Purchases/Product-purchases/product-purchases-report-filters.model';
import {ProductPurchasesReportModelService} from '../../../Models/Reports/Purchases/product-purchases-report-model.service';
import {ProviderPurchasesReportModelService} from '../../../Models/Reports/Purchases/provider-purchases-report-model.service';

@Injectable({
  providedIn: 'root'
})
export class PurchasesReportsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public productModel: ProductPurchasesReportModelService,
    public providerModel: ProviderPurchasesReportModelService,
  ) {
    super(injector);
  }

  /**
   * Obtener el informe de compras por producto
   *
   */
  public getProductPurchaseReport(filters: ProductPurchasesReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getComprasPorProducto', filters).subscribe({
        next: (response) => {
          if (save) {
            this.productModel.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener la gráfica de compras por producto
   *
   */
  public getProductPurchaseChart(filters: ProductPurchasesReportFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasComprasPorProducto', filters).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el informe de compras por proveedor
   *
   */
  public getProviderPurchaseReport(filters: ProviderPurchasesReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getComprasPorProveedor', filters).subscribe({
        next: (response) => {
          if (save) {
            this.providerModel.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener la gráfica de compras por proveedor
   *
   */
  public getProviderPurchaseChart(filters: ProviderPurchasesReportFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasComprasPorProveedor', filters).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
